import React from 'react'

const Quotations = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Quotations</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Sales</li>
            <li className="breadcrumb-item active">Quotations</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-file-text me-2"></i>
                  Quotations Management
                </h5>
                <p>Create and manage customer quotations. Generate price quotes, track quotation status, and convert quotations to orders.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Quotations

